import Box from '@mui/material/Box';
import { Accordions } from '@startengine/design-system.ui.accordions';
import { Button } from '@startengine/design-system.ui.button';
import { Divider } from '@startengine/design-system.ui.divider';
import { ChevronDownIcon, RightArrowIcon } from '@startengine/design-system.ui.icons';
import { useSearchParams } from 'next/navigation';
import { termsRisks } from './data';
import useRegDExcludedList from 'hooks/useRegDExcludedList';

const TermsAccordion = ({ offeringData }) => {
  const { data: REGD_EXCLUDED_LIST, isSuccess: loadedRegD } = useRegDExcludedList();
  const searchParams = useSearchParams();
  const isDig = searchParams.get('dig');

  const regDExclusion = loadedRegD ? !REGD_EXCLUDED_LIST?.includes(offeringData?.slug) : true;

  const isRegD =
    (offeringData?.regulationType === 'Reg D' && regDExclusion) ||
    offeringData?.regulationType === '506(c)';

  const renderTerms = (item, n) => {
    if ((item?.url !== '' || item?.detail !== '') && item?.display !== false) {
      if (
        isRegD &&
        // isApproved &&
        item?.id !== 'secRecentFiling' &&
        item?.id !== 'offeringMemorandum'
      ) {
        return null;
      }

      return (
        <>
          <Box
            sx={{
              width: '100%',
            }}
          >
            <a
              href={item?.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: 'none',
              }}
              disabled={!item?.url}
            >
              <Accordions
                {...(isDig ? { expanded: true } : {})}
                summary={`${item?.title}`}
                details={item?.detail}
                expandIcon={
                  <Button
                    icon
                    sx={{
                      padding: 0,
                      height: '36px',
                      width: '36px',
                    }}
                    data-cy={`terms-row-${item?.title}-button`}
                  >
                    {item?.url ? (
                      <RightArrowIcon
                        sx={{
                          height: '100%',
                          width: '100%',
                        }}
                      />
                    ) : (
                      <ChevronDownIcon
                        sx={{
                          height: '100%',
                          width: '100%',
                        }}
                      />
                    )}
                  </Button>
                }
                // Hacky way to get linked buttons not to expand
                {...(item?.url
                  ? {
                      expanded: false,
                    }
                  : {})}
                sx={{
                  '&::before': {
                    backgroundColor: 'transparent',
                  },
                }}
              />
            </a>
          </Box>
          {n < termsRisks(offeringData).length - 1 && (
            <Box>
              <Divider />
            </Box>
          )}
        </>
      );
    }

    return null;
  };

  return termsRisks(offeringData).map((item, n) => (
    <div key={`n-${item?.id}`}>{renderTerms(item, n)}</div>
  ));
};

export default TermsAccordion;
